import * as React from "react";

const Unauthenticated: React.FunctionComponent = ({}) => (
    <span>Not authenticated</span>
);

export { Unauthenticated };
